// extracted by mini-css-extract-plugin
export default {"image":"Login_image__aDKd5","logo":"Login_logo__+5mGa","form":"Login_form__WfNR1","Loading":"Login_Loading__yOgJ2"};